module.exports = __webpack_public_path__ + "static/media/conveyor-belt-alt.bf7df2ec.svg";